import React from "react";
import SubmittedCopyright from "../sumitted_copyright/SubmittedCopyright";

const FinalRevisedCopyright = () => {
  const fileStatus = 13;
  const applicationPath = {
    copyright: "/admin/final-revised-document-copyright",
    agreement: "/admin/final-revised-document-agreement",
  };
  const detailsRoute = "/admin/submitted-copyright-details-verify";
  const pageTitle = "সংশোধিত নথি";
  return (
    <SubmittedCopyright
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default FinalRevisedCopyright;
